<router-outlet></router-outlet>

<p-toast [breakpoints]="{'920px': {width: '90%', right: '10', left: '10'}}"></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>